import * as tslib_1 from "tslib";
import { ComponentRef, EmbeddedViewRef, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { BasePortalOutlet, CdkPortalOutlet } from '@angular/cdk/portal';
import { ESCAPE } from '@angular/cdk/keycodes';
import { FocusTrapFactory } from '@angular/cdk/a11y';
var ApDialogContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ApDialogContainer, _super);
    function ApDialogContainer(focusTrapFactory, _elementRef, _document) {
        var _this = _super.call(this) || this;
        _this.focusTrapFactory = focusTrapFactory;
        _this._elementRef = _elementRef;
        _this._document = _document;
        /** Element that was focused before the dialog was opened. Save this to restore upon close. */
        _this._elementFocusedBeforeDialogWasOpened = null;
        return _this;
    }
    ApDialogContainer.prototype.onKeyDown = function (event) {
        if (event.keyCode === ESCAPE && this._dialogRef) {
            this.dismiss(0);
        }
    };
    ApDialogContainer.prototype.ngOnInit = function () {
        var _this = this;
        //NOTE: Focus trap doesn't work when there are no focusable element on the dialog
        this._focusTrap = this.focusTrapFactory.create(this._elementRef.nativeElement);
        this._focusTrap.focusInitialElementWhenReady();
        //NOTE: This block was taken from dialog-container.ts in https://github.com/angular/components
        if (this._document) {
            this._elementFocusedBeforeDialogWasOpened = this._document.activeElement;
            // Note that there is no focus method when rendering on the server.
            if (this._elementRef.nativeElement.focus) {
                // Move focus onto the dialog immediately in order to prevent the user from accidentally
                // opening multiple dialogs at the same time. Needs to be async, because the element
                // may not be focusable immediately.
                Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
            }
        }
    };
    ApDialogContainer.prototype.ngOnDestroy = function () {
        this._focusTrap.destroy();
    };
    ApDialogContainer.prototype.setDialogRef = function (ref) {
        this._dialogRef = ref;
    };
    ApDialogContainer.prototype.attachComponentPortal = function (portal) {
        return this._portalOutlet.attachComponentPortal(portal);
    };
    ApDialogContainer.prototype.attachTemplatePortal = function (portal) {
        return this._portalOutlet.attachTemplatePortal(portal);
    };
    ApDialogContainer.prototype.dismiss = function (direction) {
        this._dialogRef.close();
        // TODO: (AT) Cannot do the below, because some dialogs are triggerred by a source element having focus.
        // If the source element is focused on close, then you would get stuck in a loop.
        if (this._elementFocusedBeforeDialogWasOpened && direction !== 0) {
            var sibling = direction > 0 ? this._elementFocusedBeforeDialogWasOpened.nextElementSibling : this._elementFocusedBeforeDialogWasOpened.previousElementSibling;
            if (sibling && sibling.focus) {
                sibling.focus();
            }
        }
    };
    return ApDialogContainer;
}(BasePortalOutlet));
export { ApDialogContainer };
